module.exports = __webpack_public_path__ + "assets/img_candidate_profile.16444d27.png";